/* eslint-disable @typescript-eslint/no-explicit-any */
import { Controller, useFormContext } from "react-hook-form";
import * as MUI from "@mui/material";

interface InputProps {
  name: string | any;
  label: string;
  type?: "text" | "number" | "date";
  ref?: any;
  maxSize: number;
}

export const FormInputText: React.FC<InputProps> = ({
  name,
  label,
  type,
  maxSize,
}) => {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { value, onChange, ...field },
        fieldState: { error },
      }) => (
        <MUI.TextField
          {...field}
          helperText={error ? error.message : false}
          error={!!error}
          value={value === undefined ? "" : value}
          label={label}
          inputProps={{ maxLength: maxSize }}
          onChange={onChange}
          size="small"
          fullWidth
          type={type}
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
        />
      )}
    />
  );
};

export const FormInputNUMBER: React.FC<InputProps> = ({
  name,
  label,
  type,
}) => {
  const { control } = useFormContext();
  return (
    <Controller
      name={name}
      control={control}
      render={({
        field: { value, onChange, ...field },
        fieldState: { error },
      }) => (
        <MUI.TextField
          {...field}
          helperText={error ? error.message : false}
          error={!!error}
          value={value === undefined ? "" : value}
          label={label}
          onChange={onChange}
          size="small"
          fullWidth
          type={type}
          variant="outlined"
          InputLabelProps={{
            shrink: true,
          }}
        />
      )}
    />
  );
};
